import api from "PFCore/api";

type SendInvitationPayload = {
  targetIds: number[];
  profileIds: number[];
  targetType: string;
};

type SendInvitationResponse = {
  existing: any[];
  saved: any[];
  unauthorized: any[];
};

export const sendInvitation = ({ targetIds, targetType, profileIds }: SendInvitationPayload) =>
  api<SendInvitationResponse>({
    url: "invites",
    method: "POST",
    data: {
      targetIds,
      targetType,
      profileIds
    }
  });
